/**
 * Inline stroke icons — a dependency-free subset in the Lucide idiom (24px grid,
 * 1.75 stroke, round joins). The collapsed sidebar rail is icon-only, so every
 * nav entry needs a mark that reads at 20px without its label.
 */

const PATHS = {
  menu: 'M3 6h18M3 12h18M3 18h18',
  close: 'M18 6 6 18M6 6l12 12',
  collapse: 'm11 17-5-5 5-5M18 17l-5-5 5-5',
  expand: 'm13 17 5-5-5-5M6 17l5-5-5-5',
  branch: 'M4 21h16M6 21V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v16M9 8h2M13 8h2M9 12h2M13 12h2M10 21v-4h4v4',
  hospital: 'M4 21h16M6 21V6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v15M12 9v6M9 12h6',
  order: 'M9 4H8a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1M9 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V4ZM9 11h6M9 15h4',
  payment: 'M2 7.5A2.5 2.5 0 0 1 4.5 5h15A2.5 2.5 0 0 1 22 7.5v9a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 16.5v-9ZM2 10.5h20M6 14.5h4',
  ledger: 'M6.5 3H20v18H6.5A2.5 2.5 0 0 1 4 18.5v-13A2.5 2.5 0 0 1 6.5 3ZM4 17.5h16M9 7.5h7M9 11h4',
  droplet: 'M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7Z',
  heart: 'M20.8 5.6a5.5 5.5 0 0 0-7.8 0L12 6.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l8.8 8.8 8.8-8.8a5.5 5.5 0 0 0 0-7.8Z',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  flask: 'M9 3h6M10 3v5.5L4.8 18A2 2 0 0 0 6.6 21h10.8a2 2 0 0 0 1.8-3L14 8.5V3M7.5 15h9',
  tag: 'M20.6 12.6 12.6 20.6a2 2 0 0 1-2.8 0l-6.4-6.4a2 2 0 0 1-.6-1.6l.5-6.1a2 2 0 0 1 1.8-1.8l6.1-.5a2 2 0 0 1 1.6.6l6.4 6.4a2 2 0 0 1 0 2.8ZM7.5 7.5h.01',
  idCard: 'M3 6.5A2.5 2.5 0 0 1 5.5 4h13A2.5 2.5 0 0 1 21 6.5v11a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 17.5v-11ZM8.5 12.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM5.5 17c.6-1.7 1.9-2.5 3-2.5s2.4.8 3 2.5M14.5 9.5h4M14.5 13h4',
  key: 'm15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4M21 2l-9.6 9.6M12.5 10.5a4 4 0 1 1-5.66 5.66 4 4 0 0 1 5.66-5.66Z',
  lock: 'M5 11h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1ZM8 11V7.5a4 4 0 0 1 8 0V11M12 15v2.5',
  logout: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
  check: 'M20 6 9 17l-5-5',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM21 21l-4.35-4.35',
  plus: 'M12 5v14M5 12h14',
  prev: 'm14 17-5-5 5-5',
  next: 'm10 7 5 5-5 5',
  calendar: 'M7 3v3M17 3v3M4 8.5A2.5 2.5 0 0 1 6.5 6h11A2.5 2.5 0 0 1 20 8.5v10A2.5 2.5 0 0 1 17.5 21h-11A2.5 2.5 0 0 1 4 18.5v-10ZM4 10.5h16M8.5 14h2M13.5 14h2M8.5 17.5h2M13.5 17.5h2',
  clipboard: 'M9 4H8a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1M9 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V4ZM9.5 11.5l1.5 1.5 3-3M9.5 16.5h5',
  trash: 'M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M10 11v6M14 11v6',
  up: 'm7 14 5-5 5 5',
  down: 'm7 10 5 5 5-5',
  upload: 'M12 16V4M8 8l4-4 4 4M4 16v2.5A2.5 2.5 0 0 0 6.5 21h11a2.5 2.5 0 0 0 2.5-2.5V16',
  // Phase 8. A van with a cross on its flank, and a bar chart for the dashboard —
  // the collapsed sidebar rail is icon-only, so each has to read at 20px unlabelled.
  ambulance: 'M3 7.5A1.5 1.5 0 0 1 4.5 6h8A1.5 1.5 0 0 1 14 7.5V17H3V7.5ZM14 10h3.2a2 2 0 0 1 1.7 1l1.7 2.8a2 2 0 0 1 .4 1.2V17h-7v-7ZM6.5 20a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM17.5 20a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM8.5 9v4M6.5 11h4',
  chart: 'M4 20V4M4 20h16M8 20v-6M13 20v-11M18 20v-7',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20 }: { name: IconName; size?: number }) {
  return (
    <svg
      className="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}

/** The brand mark: a white droplet on the signature gradient. */
export function BrandMark({ size = 34 }: { size?: number }) {
  return (
    <span className="brand-mark" style={{ width: size, height: size }} aria-hidden="true">
      <svg width={size * 0.55} height={size * 0.55} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 21.5a6.5 6.5 0 0 0 6.5-6.5c0-1.9-.95-3.65-2.8-5.15C13.85 8.35 12.45 6.1 12 3.5c-.45 2.6-1.85 4.85-3.7 6.35C6.45 11.35 5.5 13.1 5.5 15A6.5 6.5 0 0 0 12 21.5Z" />
      </svg>
    </span>
  );
}
